export default "__VITE_ASSET__CTlsrDYy__"